<template>
  <div class="NewDashboard">
    <div class="main-content">
      <dashboard-header :showBetaVersion="true"></dashboard-header>
        <div class="left-container">
          <span class="glyphicon glyphicon-menu-hamburger float-left cursor-pointer z-index" @click="openNav()"></span>
           <div id="mySidenav" class="sidenav">
            <gcc-filter-mach-2 v-if="showSilderMenu" @closeSlider="hideGCCMenu"></gcc-filter-mach-2>
           </div>
        </div>
        <div class="right-container float-right margin-top-5Point6Perc" v-bind:class="{'full-width': !showSilderMenu, 'width-80-perc': showSilderMenu}">
          <div class="row container-fluid margin-top-40px ">
            <course-count class="col-xs-6 col-sm-2 col-md-2 col-lg-2 padding-left-0px margin-bottom-3Perc"></course-count>
            <user-count class="col-xs-6 col-sm-2 col-md-2 col-lg-2 padding-left-0px margin-bottom-3Perc"></user-count>
            <div class="UserEngagedProgress col-xs-12 col-sm-8 col-sm-8 col-md-8 col-lg-8 background-color padding-top-bottom-14px">
              <radial-progress-bar class="col-xs-12 col-sm-4 col-md-4 col-lg-4 padding-left-0px" :count="loginCount" label=" Logins" :tooltip="loginTooltip" @cureentData="showParticipantDetails"></radial-progress-bar>
              <radial-progress-bar class="col-xs-12 col-sm-4 col-md-4 col-lg-4 padding-left-0px" :count="engagedCount" label=" Engaged" :tooltip="engagedTooltip" @cureentData="showParticipantDetails"></radial-progress-bar>
              <radial-progress-bar class="col-xs-12 col-sm-4 col-md-4 col-lg-4 padding-left-0px" :count="completedCount" label=" Completed" :tooltip="courseCompleteTooltip" @cureentData="showParticipantDetails"></radial-progress-bar>
            </div>
          </div>

          <!-- Slider -->
          <div id="dashboard-slider-1" class="carousel slide" data-ride="carousel" data-interval="false" v-if="false">

            <!-- Wrapper for slides -->
            <div class="carousel-inner" role="listbox">

              <!-- Slide 1 -->
              <div class="item active">
                <div class="row">
                  <div class="col-md-4 col-lg-4 col-sm-12 col-xs-12">

                    <!-- Cumulative Progress Distribution -->
                    <bar-chart width="100" height="100" title="Cumulative Progress Distribution" info="All participants in all Cohorts selected at the top."></bar-chart>
                    <!-- Cumulative Progress Distribution -->

                  </div>

                  <div class="col-md-4 col-lg-4 col-sm-12 col-xs-12">

                    <!-- Course-wise Progress Distribution -->
                    <stacked-bar-chart width="100" height="100" title="Cohort-wise Progress Distribution" info="Applies to all Cohorts selected at the top and for the Course selected in this chart's dropdown. Select more Courses at the very top to make them available in the dropdown."></stacked-bar-chart>
                    <!-- Course-wise Progress Distribution -->

                  </div>

                  <div class="col-md-4 col-lg-4 col-sm-12 col-xs-12">

                    <!-- Scoreboard -->
                    <scoreboard v-if="currDashboardTabSelection === 1" title="Scoreboard"
                                info="Some of your most important people">
                    </scoreboard>
                    <!-- Scoreboard -->

                  </div>
                </div>
              </div>
              <!-- Slide 1 -->

              <!-- Slide 2 -->
              <div class="item">
                <div class="row">
                  <div class="col-md-4">
                    <venn-chart title="Course Population"></venn-chart>
                  </div>
                </div>
              </div>
              <!-- Slide 2 -->
            </div>

            <!-- Controls -->
            <a class="left carousel-control" href="#dashboard-slider-1" role="button" data-slide="prev">
              <span class="glyphicon glyphicon-chevron-left" aria-hidden="true"></span>
              <span class="sr-only">Previous</span>
            </a>
            <a class="right carousel-control" href="#dashboard-slider-1" role="button" data-slide="next">
              <span class="glyphicon glyphicon-chevron-right" aria-hidden="true"></span>
              <span class="sr-only">Next</span>
            </a>

            <!-- Indicators -->
            <ol class="carousel-indicators">
              <li data-target="#dashboard-slider-1" data-slide-to="0" class="active"></li>
              <li data-target="#dashboard-slider-1" data-slide-to="1"></li>
            </ol>
          </div>
          <!-- Slider -->

          <div class="row min-height padding-top-2Perc">
            <div class="container-fluid">
              <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 padding-left-0px padding-right-0px">
                <!-- <data-table class="margin-left-0px margin-right-0px"
                  id="data-table"
                  :rows="stats"
                  :cols="['CourseTitle', 'CohortTitle', 'UserFullName', 'Email', 'ProgressPercent', 'DiscussionPosts', 'ChallengesTaken', 'FeedbackScore', 'LastLoginTS']">
                </data-table> -->
                <div class="row">
                  <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 padding-right-0px margin-bottom-3Perc padding-right-3Perc">
                    <tab-selection @updateTabSelection="updateTabSelectionState"></tab-selection>
                  </div>
                  <!-- <div class="col-xs-12 col-sm-4 col-md-3 col-lg-2 padding-right-0px margin-bottom-3Perc">
                    <form id="search" class="text-left">
                      <div class="col-xs-2 col-xs-offset-0 col-sm-4 col-sm-offset-0 col-md-4 col-md-offset-0 col-lg-5 col-lg-offset-0 padding-right-0px margin-top-3px">Search</div>
                     <input name="query" class="col-xs-6 col-sm-8 col-md-8 col-lg-7 padding-left-0px padding-right-0px" v-model="searchQuery">
                    </form>
                  </div> -->
                  <div class="col-xs-5 col-sm-5 col-md-5 col-lg-5 padding-left-0Perc padding-left-4Perc margin-left-3px margin-bottom-3Perc margin-top-2px">
                    <div class="form-group margin-bottom-0px" v-if="newStats.length > 0">
                      <div class="icon-addon addon-lg">
                        <input type="text" ref="input" class="form-control background-gray border-rounded"  v-model="searchQuery" autocomplete="off"/>
                        <label class="glyphicon glyphicon-search"></label>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-2 col-lg-2 col-xs-2 col-sm-2">
                    <button class="btn btn-primary btn-block unenroll-existing-button-BG black-font-color" @click="exportUserData" v-if="newStats.length > 0">Export</button>
                  </div>
                  <!--SS: PROGRESS -->
                  <!-- <div class="col-xs-6 col-xs-offset-0 col-sm-3 col-sm-offset-0 col-md-3 col-md-offset-0 col-lg-2 col-lg-offset-1 padding-left-0px padding-right-0px margin-bottom-3Perc">
                    <div class="form-group">
                      <label class="col-xs-4 col-sm-4 control-label font-weight-0 padding-left-0px padding-right-0px margin-bottom-0px padding-top-3px">Progress</label>
                      <div class="col-xs-4 col-sm-4 padding-left-1px padding-right-0px">
                        <input class="form-control padding-4-4px height-txt-bx" type="text" placeholder="min" v-model="minRange">
                      </div>
                      <div class="col-xs-4 col-sm-4 padding-left-1px padding-right-0px">
                        <input class="form-control padding-4-4px height-txt-bx" type="text" placeholder="max" v-model="maxRange">
                      </div>
                    </div>
                  </div> -->
                  <!--ss: Date Picker  -->
                  <!-- <div class="col-xs-6 col-sm-5 col-md-3 col-lg-3 padding-left-0px padding-right-0px margin-bottom-3Perc">
                    <span class="col-xs-6 col-sm-6 col-md-6 col-lg-6 padding-right-4px">
                      <date-picker v-model="startDate" :config="config" class="padding-6px-15px height-26px"></date-picker>
                    </span>
                    <span class="col-xs-6 col-sm-6 col-md-6 col-lg-6 padding-left-4px">
                      <date-picker v-model="endDate" :config="config" class="padding-6px-15px height-26px"></date-picker>
                    </span>
                  </div> -->
                  <!-- <div class="col-xs-6 col-sm-10 col-md-3 col-lg-2 padding-left-0px padding-right-0px margin-bottom-3Perc">
                    <div class="checkbox margin-top-3Point5px margin-bottom-2Point5px col-xs-9 col-xs-offset-0 col-sm-3 col-sm-offset-1 col-md-9 col-md-offset-0 col-lg-9 col-md-offset-0 padding-left-0px padding-right-0px">
                      <label><input type="checkbox" v-model="unEnrolledCheckedValues">Unenrolled users</label>
                    </div>
                    <div class="col-xs-3 col-sm-1 col-md-3 col-lg-3 padding-left-0px padding-right-0px">
                      <button type="button" class="btn btn-primary btn-xs padding-btn" @click="performOperation($event)">Go</button>
                    </div>
                  </div> -->
                </div>
                <custom-data-table
                  :data="newStats"
                  :sortColumns="sortableColumns"
                  :colsWithAlias="colsWithAlias"
                  :columns="cols"
                  :filterKey="searchQuery"
                  @selectedData="selectedExportableData"
                  v-if="newStats.length > 0">
                </custom-data-table>
                <span v-else class="no-record-found">No record(s) available.</span>
              </div>
            </div>
          </div>
        </div>
      <div class="row margin-Top-3Perc">
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
          <copy-right-footer class="footer"></copy-right-footer>    
        </div>
      </div>
    </div>
    <alert-box v-if="showAlertDialog" v-bind:errorMsg="errorMsg" @showAlertBox="updateShowAlertDialogFlag"></alert-box>
    <loader></loader>
</div>
</template>
<script>
import AlertBox from '@/components/AlertOverlay'
import CourseCount from '@/components/dashboard_v2/CourseCount'
import UserCount from '@/components/dashboard_v2/UserCount'
import TabSelection from '@/components/dashboard_v2/TabSelection'
import CopyRightFooter from '@/components/CopyrightElement'
import Header from '@/components/dashboard_v2/Header'
import { constants } from '@/utils/constants'
import Loader from '@/components/dashboard/Loader'
import VennChart from '@/components/dashboard_v2/charts/VennChart'
import GCCFilterMach2 from '@/components/dashboard_v2/GCCFilterMach2'
import { trackerService } from '@/server-util/tracker-service'
import RadialProgressBar from '@/components/dashboard_v2/RadialProgressBar'
import CustomDataTable from '@/components/dashboard_v2/CustomDataTable'
import BarChart from '@/components/dashboard/charts/BarChart'
import StackedBarChart from '@/components/dashboard/charts/StackedBarChart'
import Scoreboard from '@/components/dashboard/ListGroup'
import csvHelper from '@/utils/csv-helper'
import moment from 'moment-timezone'
import forEach from 'lodash/forEach'

// Some FontAwesome icons
import fontawesome from '@fortawesome/fontawesome'
import faSolid from '@fortawesome/fontawesome-free-solid'
import faRegular from '@fortawesome/fontawesome-free-regular'
import datePicker from 'vue-bootstrap-datetimepicker'

// Add the icon to the library so we can use it in the page
fontawesome.library.add(faSolid.faInfoCircle)
fontawesome.library.add(faSolid.faExclamationTriangle)
fontawesome.library.add(faRegular.faCopy)
fontawesome.library.add(faSolid.faDownload)
fontawesome.library.add(faSolid.faSortAmountUp)
fontawesome.library.add(faSolid.faSortAmountDown)
fontawesome.library.add(faSolid.faCheck)
fontawesome.library.add(faSolid.faCaretRight)
fontawesome.library.add(faSolid.faCaretDown)
fontawesome.library.add(faSolid.faExternalLinkAlt)
fontawesome.library.add(faSolid.faEye)

export default {
  name: 'NewDashboard',

  data: function () {
    var startTS = moment().tz('America/New_York').add(-7, 'days').format('MM/DD/YYYY')
    var endTS = moment().tz('America/New_York').format('MM/DD/YYYY')
    return {
      showSilderMenu: false,
      searchQuery: '',
      dataObj: [],
      exportableArr: [],
      csvFileName: '',
      showAlertDialog: false,
      errorMsg: '',
      selectedTab: 1,
      unEnrolledSelected: true,
      minRange: 0,
      maxRange: 100,
      startDate: startTS,
      config: {
        format: 'MM/DD/YYYY',
        useCurrent: true,
        maxDate: ''
      },
      endDate: endTS
    }
  },

  components: {
    'copy-right-footer': CopyRightFooter,
    'loader': Loader,
    'dashboard-header': Header,
    'venn-chart': VennChart,
    'course-count': CourseCount,
    'user-count': UserCount,
    'tab-selection': TabSelection,
    'gcc-filter-mach-2': GCCFilterMach2,
    'radial-progress-bar': RadialProgressBar,
    'bar-chart': BarChart,
    'stacked-bar-chart': StackedBarChart,
    'custom-data-table': CustomDataTable,
    'alert-box': AlertBox,
    'date-picker': datePicker,
    'scoreboard': Scoreboard
  },

  beforeDestroy () {
    this.eventHub.$off('groupSelected')
  },

  created () {
    this.resetTabSelectionToDefault()
    this.init()
    this.eventHub.$on('groupSelected', () => {
      this.eventHub.$emit('gccFilterUpdated')
    })
    this.trackPageLoad()
    this.setDefaultValues()
  },

  mounted () {
    this.openNav()
  },

  methods: {
    /**
     * Fetches and Sets the available Store data based on the AccountType
     * of the currently authenticated User.
     *
     * @returns null
     */
    init () {
      if (this.userIsGroupAdmin) {
        this.$store.dispatch('fetchAndSetSingleGroup', this.authUser.GroupAdminId)
      } else if (this.userIsAdmin) {
        this.$store.dispatch('fetchAndSetGroups')
      } else {
        throw new Error('You are not authorized to access this resource!')
      }
    },

    resetTabSelectionToDefault: function () {
      this.$store.state.currDashboardTabSelection = 1
    },

    updateTabSelectionState (value) {
      if (this.selectedTab !== value.selectedTabNumber) {
        this.selectedTab = value.selectedTabNumber
        this.searchQuery = ''
        this.$store.commit('setCurrTabSelection', this.selectedTab)
        this.$store.dispatch('fetchAndSetAllGroupData')
      }
      // console.log('this.selectedTab: ' + this.selectedTab)
    },

    performOperation: function (event) {
      if (this.$store.getters.filteredStats.length === 0) {
        this.showAlertDialog = true
        this.errorMsg = 'Please select course.'
        return
      } else if (this.minRange < 0) {
        this.showAlertDialog = true
        this.errorMsg = 'Min range must be greater zero.'
        return
      } else if (this.maxRange > 100) {
        this.showAlertDialog = true
        this.errorMsg = 'Max range must be greater zero.'
        return
      } else if (this.minRange > this.maxRange) {
        this.showAlertDialog = true
        this.errorMsg = 'Min range must be greater than max range.'
        return
      }
      var unEnrolledUsers = this.getFilteredDataBasedOnUnEnrollment()
      var filteredOnProgressRange = this.filterDataBasedOnProgressRange(unEnrolledUsers)
      this.dataObj = this.filterDataBasedOnDateRange(filteredOnProgressRange)
    },

    filterDataBasedOnProgressRange: function (resultsToFilter) {
      /* eslint-disable */
      let stats = resultsToFilter

      if (stats.length <= 0) {
        return 0
      }

      let filteredStats = _.filter(stats, stat => {
        return parseInt(stat.ProgressPercent) >= parseInt(this.minRange) && parseInt(stat.ProgressPercent) <= parseInt(this.maxRange)
      })

      return filteredStats
    },

    filterDataBasedOnDateRange: function (resultsToFilter) {
      /* eslint-disable */
      let stats = resultsToFilter

      if (stats.length <= 0) {
        return 0
      }

      let filteredStats = _.filter(stats, stat => {
        var dt = moment(stat.LastLoginTS).format('MM/DD/YYYY')
        return dt >= this.startDate && dt <= this.endDate
      })

      return filteredStats
    },

    selectedExportableData (value) {
      // AK: Used to export sorted data by user
      this.exportableArr = value
      // console.log('this.exportableArr: ' + JSON.stringify(this.exportableArr))
    },

    exportUserData: function () {
      if (this.exportableArr.length !== 0) {
        this.csvFileName = this.$store.getters.selectedGroup.GroupName
        var columnAlias = []
        var columnRespKey = []
        switch (this.selectedTab) {
          default:
          case 1:
            columnAlias = ['Course', 'Cohort', 'Participants', 'Email', 'Web Progress', 'Mobile Progress', 'Total Progress', 'Reflection (Comment)s', 'Role-Play Challenges', 'Ratings', 'LastLoginTS']
            columnRespKey = ['CourseTitle', 'CohortTitle', 'UserFullName', 'Email', 'WebProgressPercent', 'MobileProgressPercent', 'ProgressPercent', 'DiscussionPosts', 'ChallengesTaken', 'FeedbackScore', 'LastLoginTS']
            break
          case 2:
            columnAlias = ['Moment Name', 'Type of moment', 'Cohort Name', 'Release Date', 'Expiry Date', 'Logins (#)', 'Logins (%)', 'Started reading (#)', 'Started reading (%)', 'Completed reading (#)', 'Completed reading (%)', 'R&D Engagement (#)', 'R&D Engagement (%)', 'Rating (1) (#)', 'Rating (1) (%)', 'Rating (2) (#)', 'Rating (2) (%)', 'Rating (3) (#)', 'Rating (3) (%)', 'Rating (4) (#)', 'Rating (4) (%)', 'Rating (4-5) (#)', 'Rating (4-5) (%)', 'Rating (5) (#)', 'Rating (5) (%)', 'Bookmarked (#)', 'Bookmarked (%)', 'Notification (#)', 'Notification (%)', 'Total Ratings']
            columnRespKey = ['CourseTitle', 'TypeOfMoment', 'CohortName', 'ReleaseDate', 'ExpiryDate', 'TotalLogins', 'PercentLogins', 'TotalViews', 'PercentViewsByLogins', 'TotalCompletions', 'PercentCompletionByViews', 'UniqueUserCountForRDResponses', 'PercentUniqueRDResponsesByViews', 'Ratings1Star', 'Percent1RatingsByTotalRatings', 'Ratings2Star', 'Percent2RatingsByTotalRatings', 'Ratings3Star', 'Percent3RatingsByTotalRatings', 'Ratings4Star', 'Percent4RatingsByTotalRatings', 'Ratings4Or5Star', 'Percent4or5RatingByTotalRatings', 'Ratings5Star', 'Percent5RatingByTotalRatings', 'TotalBookmarks', 'PercentBookmarkByViews', 'NotifClicked', 'PercentNotifByLogins', 'TotalRatings']
            break
        }
        return csvHelper.export(this.exportableArr, columnRespKey, columnAlias, this.csvFileName)
      } else {
        this.showAlertDialog = true
        this.errorMsg = 'No data found for export.'
      }
    },

    openNav: function () {
      this.showSilderMenu = true
      document.getElementById('mySidenav').style.width = '20%'
      if (window.innerWidth < 768) {
        document.getElementById('mySidenav').style.width = '100%'
      }
    },

    hideGCCMenu (value) {
      if (value) {
        this.showSilderMenu = false
        document.getElementById('mySidenav').style.width = '0%'
      }
    },

    getAllGroupData () {
      this.$store.dispatch('fetchAndSetAllGroupData')
    },

    /**
     * FIXME: Let's get a proper doc in here.
     * Tracks Page loads???
     *
     * @returns null
     */
    trackPageLoad () {
      let store = this.$store
      let accessToken = store.state.access_token
      let userDataForActivity = `
        UserName: ${this.authUser.UserName},
        FullName: ${this.authUser.FirstName} ${this.authUser.LastName},
        Email: ${this.authUser.Email}
      `

      let trackingObj = {
        ActivityData: 'View Dashboard , ' + userDataForActivity,
        ActivityType: constants.AdminActivityType.Manage_Dashboard,
        AdminAction: constants.AdminActionType.LoadScreen,
        ScreenName: 'DASHBOARD',
        UserRole: store.state.curr_user.AccountType,
        IsPrivate: false
      }
      trackerService.logActivity(accessToken, trackingObj).then(responseObj3 => {
        if (responseObj3.status === 200) {
          console.log('LOGGED ACTIVITY : ')
        }
      })
    },

    showParticipantDetails (value) {
      // AK: To get and show sorted data to Admin based on current data selection
      this.currOperation = this.stripHtml(value.label).trim()
      // console.log('this.currOperation >>> ' + this.currOperation)
      switch (this.currOperation) {
        default:
        case 'Logins':
          this.dataObj = this.loginUserObj
          break
        case 'Engaged':
          this.dataObj = this.engagedUserObj
          break
        case 'Completed':
          this.dataObj = this.completedUserObj
          break
      }
    },

    stripHtml: function (html) {
      // Create a new div element
      var temporalDivElement = document.createElement('div')
      // Set the HTML content with the provided
      temporalDivElement.innerHTML = html
      // Retrieve the text property of the element (cross-browser support)
      return temporalDivElement.textContent || temporalDivElement.innerText || ''
    },

    setDefaultValues: function () {
      this.config.maxDate = new Date()
      this.dataObj = this.stats
      this.unEnrolledSelected = true
      this.exportRecordArr = this.getFilteredDataBasedOnUnEnrollment()
    },

    updateShowAlertDialogFlag (value) {
      this.showAlertDialog = value
    },

    getFilteredDataBasedOnUnEnrollment: function () {
      /* eslint-disable */
      let stats = this.$store.getters.filteredStats
      let filteredStats = stats

      if (stats.length <= 0) {
        return 0
      }

      if (!this.unEnrolledCheckedValues) {
        // console.log('Removed Un-enrolled users')
        filteredStats = _.filter(stats, stat => {
          return stat.isUnEnrolled === this.unEnrolledSelected
        })
      }

      return filteredStats
    }
  },

  computed: {
    unEnrolledCheckedValues: {
      get: function () {
        return this.unEnrolledSelected
      },
      set: function (newValue) {
        this.unEnrolledSelected = newValue
      }
    },

    loginTooltip () {
      return constants.Login_Tooltip
    },

    engagedTooltip () {
      return constants.Engaged_Tooltip
    },

    courseCompleteTooltip () {
      return constants.Completed_Tooltip
    },

    authUser () {
      return this.$store.state.curr_user
    },

    userIsGroupAdmin () {
      return this.$store.getters.userIsGroupAdmin
    },

    currDashboardTabSelection: {
      get: function () {
        return this.$store.getters.currDashboardTabSelection
      }
    },

    userIsAdmin () {
      return this.$store.getters.userIsAdmin
    },

    stats () {
      return this.$store.getters.filteredStats
    },

    newStats () {
      // AK: return original or sorted list
      return this.dataObj
    },

    colsWithAlias () {
      var columnAlias = []
      var columnRespKey = []
      var columnNameToShow = []
      switch (parseInt(this.selectedTab)) {
        default:
        case 1:
          columnAlias = ['Course', 'Cohort', 'Participants', 'Email', 'Web Progress', 'Mobile Progress', 'Total Progress', 'Reflection (Comment)s', 'Role-Play Challenges', 'Ratings', 'LastLoginTS']
          columnRespKey = ['CourseTitle', 'CohortTitle', 'UserFullName', 'Email', 'WebProgressPercent', 'MobileProgressPercent', 'ProgressPercent', 'DiscussionPosts', 'ChallengesTaken', 'FeedbackScore', 'LastLoginTS']
          break
        case 2:
          columnAlias = ['Moment Name', 'Type of moment', 'Cohort Name', 'Release Date', 'Expiry Date', 'Logins (#)', 'Logins (%)', 'Started reading (#)', 'Started reading (%)', 'Completed reading (#)', 'Completed reading (%)', 'R&D Engagement (#)', 'R&D Engagement (%)', 'Rating (1) (#)', 'Rating (1) (%)', 'Rating (2) (#)', 'Rating (2) (%)', 'Rating (3) (#)', 'Rating (3) (%)', 'Rating (4) (#)', 'Rating (4) (%)', 'Rating (4-5) (#)', 'Rating (4-5) (%)', 'Rating (5) (#)', 'Rating (5) (%)', 'Bookmarked (#)', 'Bookmarked (%)', 'Notification (#)', 'Notification (%)', 'Total Ratings']
          columnRespKey = ['CourseTitle', 'TypeOfMoment', 'CohortName', 'ReleaseDate', 'ExpiryDate', 'TotalLogins', 'PercentLogins', 'TotalViews', 'PercentViewsByLogins', 'TotalCompletions', 'PercentCompletionByViews', 'UniqueUserCountForRDResponses', 'PercentUniqueRDResponsesByViews', 'Ratings1Star', 'Percent1RatingsByTotalRatings', 'Ratings2Star', 'Percent2RatingsByTotalRatings', 'Ratings3Star', 'Percent3RatingsByTotalRatings', 'Ratings4Star', 'Percent4RatingsByTotalRatings', 'Ratings4Or5Star', 'Percent4or5RatingByTotalRatings', 'Ratings5Star', 'Percent5RatingByTotalRatings', 'TotalBookmarks', 'PercentBookmarkByViews', 'NotifClicked', 'PercentNotifByLogins', 'TotalRatings']
          break
      }
      for (var i = 0; i < columnRespKey.length; i++) {
        var obj = {
          ColumnName: columnRespKey[i],
          ColumnAlias: columnAlias[i]
        }
        columnNameToShow.push(obj)
      }
      return columnNameToShow
    },

    cols () {
      switch (parseInt(this.selectedTab)) {
        default:
        case 1:
          return ['CourseTitle', 'CohortTitle', 'UserFullName', 'Email', 'WebProgressPercent', 'MobileProgressPercent', 'ProgressPercent', 'DiscussionPosts', 'ChallengesTaken', 'FeedbackScore', 'LastLoginTS']
          break
        case 2:
          return ['CourseTitle', 'TypeOfMoment', 'CohortName', 'ReleaseDate', 'ExpiryDate', 'TotalLogins', 'PercentLogins', 'TotalViews', 'PercentViewsByLogins', 'TotalCompletions', 'PercentCompletionByViews', 'UniqueUserCountForRDResponses', 'PercentUniqueRDResponsesByViews', 'Ratings1Star', 'Percent1RatingsByTotalRatings', 'Ratings2Star', 'Percent2RatingsByTotalRatings', 'Ratings3Star', 'Percent3RatingsByTotalRatings', 'Ratings4Star', 'Percent4RatingsByTotalRatings', 'Ratings4Or5Star', 'Percent4or5RatingByTotalRatings', 'Ratings5Star', 'Percent5RatingByTotalRatings', 'TotalBookmarks', 'PercentBookmarkByViews', 'NotifClicked', 'PercentNotifByLogins', 'TotalRatings']
          break
      }
    },

    sortableColumns () {
      switch (parseInt(this.selectedTab)) {
        default:
        case 1:
          return ['CourseTitle', 'CohortTitle', 'UserFullName', 'Email', 'WebProgressPercent', 'MobileProgressPercent', 'ProgressPercent', 'DiscussionPosts', 'ChallengesTaken', 'FeedbackScore']
          break
        case 2:
          return ['CohortName', 'TypeOfMoment', 'ExpiryDate', 'CourseTitle', 'TotalUsers', 'TotalLogins', 'TotalViews', 'TotalCompletions', 'TotalCompletionExceptRatings', 'TotalRatings', 'Ratings1Star', 'Ratings2Star', 'Ratings3Star', 'Ratings4Star', 'Ratings5Star', 'Ratings4Or5Star', 'NotifClicked', 'UniqueUserCountForRDResponses', 'TotalRDResponses', 'TotalBookmarks']
          break
      }
    },

    getUpdatedGCCList: {
      get: function () {
        // console.log('Final List >>>> ' + JSON.stringify(this.$store.state.gccData))
        return this.$store.state.gccData
      }
    },

    loginCount () {
      /* eslint-disable */
      let allFilteredStats = this.$store.getters.filteredStats

      /*
      if (allFilteredStats.length <= 0) {
        return 0
      }
      */

      switch (this.selectedTab) {
        default:
        case 1:
          let filteredStatsCount = _.filter(allFilteredStats, stat => {
            return !_.includes(stat.LastLoginTS, '01/01/0001')
          }).length
          return filteredStatsCount > 0 && allFilteredStats.length > 0 ? _.round((filteredStatsCount / allFilteredStats.length) * 100) : 0
          break
        case 2:
          let sumOfAllTotalLogins = 0
          let sumOfTotalUsers = 0
          // console.log('*** stats: ' + JSON.stringify(allFilteredStats))
          forEach(allFilteredStats, stat => {
            sumOfAllTotalLogins += stat.TotalLogins
          })
          forEach(allFilteredStats, stat => {
            sumOfTotalUsers += stat.TotalUsers
          })
          // console.log('1: sumOfAllTotalLogins: ' + sumOfAllTotalLogins + ' sumOfTotalUsers: ' + sumOfTotalUsers + ' .round((sumOfAllTotalLogins / sumOfTotalUsers) * 100): ' + _.round((sumOfAllTotalLogins / sumOfTotalUsers) * 100))
          return sumOfAllTotalLogins > 0 && sumOfTotalUsers > 0 ? _.round((sumOfAllTotalLogins / sumOfTotalUsers) * 100) : 0
          break
      }
      /* eslint-enable */
    },

    engagedCount () {
      /* eslint-disable */
      let stats = this.$store.getters.filteredStats

      /*
      if (stats.length <= 0) {
        return 0
      }
      */

      switch (this.selectedTab) {
        default:
        case 1:
          let filteredStatsCount = _.filter(stats, stat => {
            return _.parseInt(stat.ProgressPercent) > 0
          }).length
          return filteredStatsCount > 0 && stats.length > 0 ? _.round((filteredStatsCount / stats.length) * 100) : 0
          break
        case 2:
          let sumOfAllTotalViews = 0
          let sumOfTotalUsers = 0
          // console.log('*** stats: ' + stats.length)
          forEach(stats, stat => {
            // console.log('Previous value: ' + sumOfAllTotalViews + ' upcoming value: ' + stat.TotalViews)
            sumOfAllTotalViews += stat.TotalViews
          })
          forEach(stats, stat => {
            sumOfTotalUsers += stat.TotalUsers
          })
          // console.log('2: sumOfAllTotalViews: ' + sumOfAllTotalViews + ' sumOfTotalUsers: ' + sumOfTotalUsers + ' .round((sumOfAllTotalViews / sumOfTotalUsers) * 100): ' + _.round((sumOfAllTotalViews / sumOfTotalUsers) * 100))
          return sumOfAllTotalViews > 0 && sumOfTotalUsers > 0 ? _.round((sumOfAllTotalViews / sumOfTotalUsers) * 100) : 0
          break
      }
      /* eslint-enable */
    },

    completedCount () {
      /* eslint-disable */
      let stats = this.$store.getters.filteredStats

      /*
      if (stats.length <= 0) {
        return 0
      }
      */

      switch (this.selectedTab) {
        default:
        case 1:
          let filteredStatsCount = _.filter(stats, stat => {
            return _.parseInt(stat.ProgressPercent) === 100
          }).length
          return filteredStatsCount > 0 && stats.length > 0 ? _.round((filteredStatsCount / stats.length) * 100) : 0
          break
        case 2:
          let sumOfTotalCompletionExceptRatings = 0
          let sumOfTotalUsers = 0
          // console.log('*** stats: ' + stats.length)
          forEach(stats, stat => {
            // console.log('Previous value: ' + sumOfTotalCompletionExceptRatings + ' upcoming value: ' + stat.TotalCompletionExceptRatings)
            sumOfTotalCompletionExceptRatings += stat.TotalCompletionExceptRatings
          })
          forEach(stats, stat => {
            sumOfTotalUsers += stat.TotalUsers
          })
          // console.log('3: sumOfTotalCompletionExceptRatings: ' + sumOfTotalCompletionExceptRatings + ' sumOfTotalUsers: ' + sumOfTotalUsers + ' .round((sumOfTotalCompletionExceptRatings / sumOfTotalUsers) * 100): ' + _.round((sumOfTotalCompletionExceptRatings / sumOfTotalUsers) * 100))
          return sumOfTotalCompletionExceptRatings > 0 && sumOfTotalUsers > 0 ? _.round((sumOfTotalCompletionExceptRatings / sumOfTotalUsers) * 100) : 0
          break
      }
      /* eslint-enable */
    },

    loginUserObj () {
      /* eslint-disable */
      let stats = this.$store.getters.filteredStats

      let filteredStats = []
      switch (this.selectedTab) {
        default:
        case 1:
          filteredStats = _.filter(stats, stat => {
            return !_.includes(stat.LastLoginTS, '01/01/0001')
          })
          break
        case 2:
          filteredStats = _.filter(stats, stat => {
            return parseInt(stat.TotalLogins) > 0
          })
          break
      }
      return filteredStats
      /* eslint-enable */
    },

    engagedUserObj () {
      /* eslint-disable */
      let stats = this.$store.getters.filteredStats

      // console.log('2 ::: ' + JSON.stringify(stats))
      let filteredStats = []
      switch (this.selectedTab) {
        default:
        case 1:
          filteredStats = _.filter(stats, stat => {
            return _.parseInt(stat.ProgressPercent) > 0
          })
          break
        case 2:
          filteredStats = _.filter(stats, stat => {
            return parseInt(stat.TotalViews) > 0
          })
          break
      }

      return filteredStats
      /* eslint-enable */
    },

    completedUserObj () {
      /* eslint-disable */
      let stats = this.$store.getters.filteredStats
      
      // console.log('3 ::: ' + JSON.stringify(stats))
      let filteredStats = []
      switch (this.selectedTab) {
        default:
        case 1:
          filteredStats = _.filter(stats, stat => {
            return _.parseInt(stat.ProgressPercent) === 100
          })
          break
        case 2:
          filteredStats = _.filter(stats, stat => {
            return parseInt(stat.TotalCompletions) > 0
          })
          break
      }

      return filteredStats
      /* eslint-enable */
    }
  },

  watch: {
    stats: function (newValue, oldValue) {
      this.setDefaultValues()
    }
  }

}
</script>

<style lang="scss" scoped>
.NewDashboard {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  height: 100vh;
}
.border-red{
  border: 1px solid red;
}
.border-yellow{
  border: 2px solid yellow;
}
.margin-left-1point5Perc{
  margin-left:1.5% !important;
}
.margin-right-1point5Perc{
  margin-right:1.5% !important;
}
.width-97Point4{
  width:97.4% !important;
}
.sendGridList{
  min-height: 57vh;
}
/* Using Only for footer */
.footer{
    /* position: fixed; */
    left: 0;
    bottom: 0;
    width: 100%;
    /* background-color: red; */
    /* color: white; */
    text-align: center;
    margin-bottom: 1%;
    font-size: 12px;
}
.cursor-pointer {
  cursor: pointer;
}

.sidenav {
    height: 91%;
    width: 0;
    position: fixed;
    z-index: 1;
    top: 70px;
    left: 0;
    background-color: #dcdcdc;
    overflow-x: hidden;
    overflow-y: auto;
    transition: 0.5s;
    padding-top: 10px;
}

.sidenav a {
    padding: 8px 8px 8px 32px;
    text-decoration: none;
    font-size: 25px;
    color: #818181;
    display: block;
    transition: 0.3s;
}

.sidenav a:hover {
    color: #f1f1f1;
}

.sidenav .closebtn {
    position: absolute;
    top: 0;
    right: 25px;
    font-size: 36px;
    margin-left: 50px;
}

@media screen and (max-height: 450px) {
  .sidenav {padding-top: 15px;}
  .sidenav a {font-size: 18px;}
}
.text-align-left {
  text-align: left !important;
}
.float-left {
  float: left !important;
}
.glyphicon {
  font-size: 30px;
}
.right-container {
  width: 80% !important;
}
.float-right {
  float: right !important;
}
.color-red{
  border: 1px solid red;
}
.text-align-right{
  text-align: right;
}
.margin-top-bottom{
  margin-top:27px;
  margin-bottom:10px;
}
.margin-right-2Perc{
  margin-right: 2%;
}
.full-width {
  width: 100% !important;
  transition: 0.5s;
}
.width-80-perc {
  width: 80% !important;
  transition: 0.5s;
}

.z-index{
  position: fixed;
  left: 13px;
  top: 75px;
  z-index: 1;
}
.height-1Perc{
  height:1%;
}
.red-border{
  border: 1px solid red;
}
.margin-top-5Point6Perc{
  margin-top:5.6%;
}
.position-fixed{
  position:fixed;
}
.margin-top-40px{
  margin-top:40px;
}
.padding-left-0px{
  padding-left:0px;
}
.margin-bottom-3Perc{
  margin-bottom: 3%;
}
.background-color{
  background-color:#fafafa;
}
::-webkit-scrollbar,
scrollbar {
  display: none;
}
.margin-bottom-8Perc{
  margin-bottom:8%;
}
.padding-right-0px{
  padding-right:0px;
}
.margin-left-0px{
  margin-left:0px;
}
.margin-right-0px{
  margin-right:0px;
}
.min-height {
  min-height: 50vh;
}
.padding-top-bottom-14px{
  padding-top:14px;
  padding-bottom: 14px;
}
.font-size-14px{
  font-size:14px;
}
.padding-left-5Point7Perc{
 padding-left:5.7%;
}
.font-size-16px{
  font-size:16px;
}
.padding-top-1Point5px{
 padding-top:1.5px;
}
.padding-right-3Perc{
  padding-right:3%;
}
.margin-top-3Point5px{
  margin-top:3.5px;
}
.margin-bottom-2Point5px{
  margin-bottom:2.5px;
}
.padding-top-2Perc{
 padding-top:2%;
}
.height-txt-bx{
  height:26px;
}
.margin-bottom-0px{
  margin-bottom:0px;
}
.vertical-align {
  display: flex;
  align-items: center;
}
.font-weight-0{
  font-weight:normal;
}
.padding-4-4px{
  padding: 4px 4px;
}
.padding-top-3px{
  padding-top:3px;
}
.padding-left-1px{
  padding-left: 0.5em;
}
.padding-right-1em{
  padding-right: 1em;
}
.padding-btn{
  padding: 3px 5px;
}
.padding-6px-15px{
  padding: 6px 15px;
}
.height-26px{
  height: 26px;
}
.margin-top-1px{
  margin-top: 1px;
}
.margin-top-3px{
  margin-top:3px;
}
.padding-left-4px{
  padding-left:4px;
}
.padding-right-4px{
  padding-right:4px;
}

#dashboard-slider-1 {
  min-height: 360px;
}

.carousel-control {
  background-color: transparent !important;
  background-image: none !important;
  width: 50px !important;

  span.glyphicon {
    color: rgb(39, 52, 91);
  }
}

.carousel-indicators {
  bottom: -10px !important;
  z-index: 1;

  li {
    border: 1px solid rgba(39, 52, 91, 0.7);
    background-color: rgba(39, 52, 91, 0.7);
  }

  li:hover,
  li:focus,
  li:active,
  li:visited,
  li.active {
    border: 1px solid rgba(39, 52, 91, 1);
    background-color: rgba(39, 52, 91, 1);
  }
}
.padding-left-0Perc{
 padding-left:0%;
}
.margin-left-3px{
  margin-left:3px !important;
}
.margin-right-10px{
  margin-right:10px;
}
.input-group .icon-addon .form-control {
  border-radius: 0;
}
.icon-addon {
  position: relative;
  color: #555;
  display: block;
}
.icon-addon:after,
.icon-addon:before {
  display: table;
  content: " ";
}
.icon-addon:after {
  clear: both;
}
.icon-addon.addon-md .glyphicon,
.icon-addon .glyphicon,
.icon-addon.addon-md .fa,
.icon-addon .fa {
  position: absolute;
  z-index: 2;
  left: 10px;
  font-size: 14px;
  width: 20px;
  margin-left: -2.5px;
  text-align: center;
  padding: 8px 0;
  top: 1px;
}
.icon-addon.addon-lg .form-control {
  line-height: 1.33;
  height: 30px;
  border-radius: 15px;
  font-size: 13px;
  padding: 7px 16px 6px 40px;
}
.icon-addon.addon-sm .form-control {
  height: 30px;
  padding: 5px 10px 5px 28px;
  font-size: 12px;
  line-height: 1.5;
}
.icon-addon.addon-lg .fa,
.icon-addon.addon-lg .glyphicon {
  font-size: 14px;
  margin-left: 0;
  left: 11px;
  top: 0px;
}
.icon-addon.addon-md .form-control,
.icon-addon .form-control {
  padding-left: 30px;
  float: left;
  font-weight: normal;
}
.icon-addon.addon-sm .fa,
.icon-addon.addon-sm .glyphicon {
  margin-left: 0;
  font-size: 12px;
  left: 5px;
  top: -1px;
}
.icon-addon .form-control:focus + .glyphicon,
.icon-addon:hover .glyphicon,
.icon-addon .form-control:focus + .fa,
.icon-addon:hover .fa {
  color: #555;
}
.background-gray {
  background-color: #ddd;
}
.border-rounded {
  border-bottom-right-radius: 12.5%;
  border-top-left-radius: 12.5%;
  border-top-right-radius: 12.5%;
  border-bottom-left-radius: 12.5%;
}
.padding-left-4Perc {
  padding-left: 4%;
}
.unenroll-existing-button-BG {
  background-color: #f39c12 !important;
  border: 1px solid #f39c12 !important;
}
.padding-6px-6px{
  padding: 6px 6px;
}
.black-font-color {
  color: #000;
}
.margin-top-2px {
  margin-top: 2px;
}
.no-record-found {
  font-size: 15px;
  color: #f39c12;
  font-weight: 600;
  font-style: italic;
}
</style>



// WEBPACK FOOTER //
// src/pages/NewDashboard.vue